'use client';

import { Fragment, useContext, useEffect, useState } from 'react';

import { GrClose } from 'react-icons/gr';

import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  Transition,
  TransitionChild,
} from '@headlessui/react';

import { useLocale, useTranslations } from 'next-intl';
import { ReportContext } from '@/app/providers/reportProvider';
import { useRouter } from '@/i18n/routing';
import Link from 'next/link';

export default function RedirectPopUp() {
  const [isOpen, setIsOpen] = useState(false);
  const [isClosed, setIsClosed] = useState(false);
  const locale = useLocale();
  const t = useTranslations('redirect_popup');
  const report = useContext(ReportContext);
  const router = useRouter();

  useEffect(() => {
    function handleScroll() {
      if (!isClosed && (locale === 'ja' || locale === 'ko')) {
        const ele = document.getElementById('about-report-1');
        if (window.scrollY >= ele.offsetHeight + 100) {
          setIsOpen(true);
        }
      }
    }

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  });

  const baseUrl =
    process.env.NODE_ENV !== 'production'
      ? 'http://localhost:3000'
      : 'https://www.coherentmi.com';

  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-20" onClose={() => false}>
        <DialogBackdrop className="fixed inset-0 bg-black/30" />
        <div className="flex min-h-full items-center justify-center p-4 text-center fixed inset-0  w-screen">
          <TransitionChild
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <DialogPanel
              as="div"
              transition={true}
              className='w-full lg:w-1/2 h-60 max-w-md transform overflow-hidden rounded-2xl p-2 bg-[url("/redirectpoupbg.webp")] bg-cover text-center shadow-xl transition-all relative'
            >
              <div className="text-end">
                <button
                  onClick={() => {
                    setIsOpen(false);
                    setIsClosed(true);
                  }}
                  className="btn border ring-1 ring-blue-300 border-white bg-gray-500 text-white rounded-lg"
                >
                  <GrClose size={25} className="p-1" />
                </button>
              </div>
              <div className="flex h-full">
                <div className="mt-8 text-center mx-3">
                  <p className="text-2xl font-semibold text-white mb-2">
                    {t('heading')}
                  </p>
                  <Link
                    href={`${baseUrl}/en/industry-reports/${report.CustomName}`}
                    target="_blank"
                    className="text-sm font-semibold text-white hover:!underline cursor-pointer"
                  >
                    {t('link')}
                  </Link>
                </div>
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </Dialog>
    </Transition>
  );
}
